@if (!currentRoute().startsWith('/11-plus-online-comprehension-extract')) {
  <app-header></app-header>
}
<main class="main-content container" [class.no-chrome]="currentRoute().startsWith('/11-plus-online-comprehension-extract')">
  <router-outlet></router-outlet>
  @if (showModal) {
    <app-modal-popup-component
      [config]="modalConfig"
      [isVisible]="showModal"
      (confirm)="onConfirm()"
      (reject)="onReject()"
      (closeModal)="onModalClose()"
    />
  }
</main>

@if (cookieBannerVisible() && !currentRoute().startsWith('/cookies')) {
  <section class="cookie-banner" aria-label="Cookie notice" role="dialog" aria-live="polite">
    <div class="cookie-content">
      <p class="cookie-banner__text flex-column">
      <div class="cookie-banner__text">
        <h4>
          Your privacy and cookie settings
        </h4>
        <p>
          We use cookies and other technologies to allow our site to function properly, alongside optional cookies which
          help us understand how people use our sites and personalise our ads. You may choose to accept all cookies,
          reject all non-essential cookies, or customise your preferences at any time. <br><br>
        </p>
      </div>
      <div class="cookie-banner__actions">
        <button type="button" class="btn btn-outline-secondary btn-sm btn-cookie btn-cookie-page" (click)="gotToCookiePage()">Cookie
          settings
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm btn-cookie" (click)="dismissCookieBanner()">Reject all
        </button>
        <button type="button" class="btn btn-warning btn-sm btn-cookie" (click)="acceptCookies()">Accept all
        </button>
      </div>
    </div>
  </section>
}
@if (!currentRoute().includes('/products/') && !currentRoute().includes('/samples/') && !currentRoute().startsWith('/11-plus-online-comprehension-extract')) {
  <app-footer-component></app-footer-component>
}
